import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'components/graphql'
import { RestaurantContext } from 'sections/options/sections/RestaurantDesigner/RestaurantDesignerHandler'
import { Text } from 'components/forms'
import { ConfirmModal } from 'components/Modal'
import { mutation } from '../../helpers'

import { StyledFormInput, StyledInputRemove } from './styled'

const RoomInput = ({ mutations: { delete: { rawDeleteRoom } }, roomItem, roomKey }) => {
	const [t] = useTranslation()
	const { currentProjectIds, setCurrentProjectIds } = useContext(RestaurantContext)
	const [deleteRoom] = useMutation(rawDeleteRoom)
	const handleDeleteRoom = (e) => {
		e.stopPropagation()

		return ConfirmModal({
			show: true,
			label: t('common.buttons.confirm'),
			text: t('restaurant_designer_section.strings.confirm_room_delete')
		}).then(()=>{
			if(roomItem.id === currentProjectIds.roomId) { //if the deleting room is 'active room'
				setCurrentProjectIds({
					...currentProjectIds, roomId: null
				})
			}
		}).then(()=>mutation(deleteRoom, { id: roomItem.id }))
	}

	let roomPath = `rooms[${roomKey}]`
	return roomItem ? (
		<StyledFormInput key={roomItem.id}>
			<Text
				field={`${roomPath}.id`}
				hidden
			/><Text
				field={`${roomPath}.caption`}
				label={t('restaurant_designer_section.fields.room_input_label')}
			/>
			{roomItem.id && <StyledInputRemove onClick={(e)=>handleDeleteRoom(e)} />}
		</StyledFormInput>
	) : <div/>
}


export default RoomInput
